const initialState = [
  {
    id: 1,
    img: "https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80",
    title: " Boost your conversion rate",
    cetagory: "Article",
    author: {
      id: 1,
      name: " Learn with sumit",
      profile: "https://avatars.githubusercontent.com/u/73503432?v=4",
    },
    date: "11 Jul, 2022",
    reading: "6 min read",
  },
  {
    id: 2,
    img: "https://images.unsplash.com/photo-1547586696-ea22b4d4235d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80",
    title: " How to use search engine optimization to drive sales",
    cetagory: "Tech",
    author: {
      id: 2,
      name: " akkk blog",
      profile:
        "https://images.unsplash.com/photo-1588354924596-71b1cb1393fb?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
    },
    date: "12 Jul, 2022",
    reading: "7 min read",
  },
  {
    id: 3,
    img: "https://images.unsplash.com/photo-1492724441997-5dc865305da7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80",
    title: " Improve your customer experience",
    cetagory: "Sels",
    author: {
      id: 1,
      name: " Learn with sumit",
      profile: "https://avatars.githubusercontent.com/u/73503432?v=4",
    },
    date: "18 Jul, 2022",
    reading: "15 min read",
  },
  {
    id: 4,
    img: "https://images.unsplash.com/photo-1503252947848-7338d3f92f31?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1031&q=80",
    title: " Boost your Coding Speed",
    cetagory: "Tech",
    author: {
      id: 1,
      name: " Learn with sumit",
      profile: "https://avatars.githubusercontent.com/u/73503432?v=4",
    },
    date: "11 Jul, 2022",
    reading: "15 min read",
  },
  {
    id: 5,
    img: "https://images.unsplash.com/photo-1591696205602-2f950c417cb9?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
    title: " Who to sales effectively",
    cetagory: "Sales",
    author: {
      name: " akkk blog",
      id: 2,
      profile:
        "https://images.unsplash.com/photo-1588354924596-71b1cb1393fb?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
    },
    date: "12 Jul, 2022",
    reading: "7 min read",
  },
  {
    id: 6,
    img: "https://i.ibb.co/G9Cp8KQ/6g.jpg",
    title: " 6G is published",
    cetagory: "Article",
    author: {
      name: " Learn with sumit",
      id: 1,
      profile: "https://avatars.githubusercontent.com/u/73503432?v=4",
    },
    date: "25 Jul, 2022",
    reading: "9 min read",
  },
  {
    id: 7,
    img: "https://images.unsplash.com/photo-1639322537231-2f206e06af84?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1032&q=80",
    title: " What is BlockChain",
    cetagory: "Tech",
    author: {
      name: " Learn with sumit",
      id: 1,
      profile: "https://avatars.githubusercontent.com/u/73503432?v=4",
    },
    date: "15 Jun, 2022",
    reading: "12 min read",
  },
  {
    id: 8,
    img: "https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=869&q=80https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=869&q=80",
    title: " Who to Manage Customer",
    cetagory: "Sales",
    author: {
      name: " akkk blog",
      id: 2,
      profile:
        "https://images.unsplash.com/photo-1588354924596-71b1cb1393fb?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
    },
    date: "11 Jul, 2022",
    reading: "8 min read",
  },
  {
    id: 9,
    img: "https://images.unsplash.com/photo-1622630998477-20aa696ecb05?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=946&q=80",
    title: " What is Crypto Currency",
    cetagory: "Article",
    author: {
      name: " akkk blog",
      id: 2,
      profile:
        "https://images.unsplash.com/photo-1588354924596-71b1cb1393fb?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
    },
    date: "25 Jul, 2022",
    reading: "9 min read",
  },
];

export default initialState;
